import React from "react";
import "./NewMenuBadge.css";

/** Small yellow NEW pill shown next to a menu name. */
export default function NewMenuBadge({ dot = false }) {
  if (dot) return <span className="nmb-dot" title="Something new inside" aria-label="New inside" />;
  return <span className="nmb-pill" title="New menu">NEW</span>;
}
